import Menu from './Menu'
import { useNavigate } from "react-router-dom";
import { useState } from 'react'
import SearchDrawer from './common/SearchDrawer'

const TopHeader=()=> {
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();

  const logoClick=()=> {
        const ss_start_time = sessionStorage.getItem("session_start");
        const now = new Date().getTime();
        if(now - ss_start_time > 300000) {
          console.log("5sec. reset 'top' session");
          sessionStorage.removeItem("top");
          sessionStorage.setItem("session_start", new Date().getTime());
        }
        navigate("/");
  }

  return <div  name="top">
     <div className="top_logo_sp" onClick={logoClick}>
       <img src="https://towershibuya.jp/assets/images/svg/top_logo_sp.svg" alt="logo"/>
     </div>

    <div className="top_header">
      <div className="top_logo" onClick={logoClick}>
        <img src="https://towershibuya.jp/assets/images/svg/top_logo2.svg" alt="logo"/>
      </div>
      <div>
        <div className="top-menu">
          <Menu setSearchOpen={setSearchOpen} />
        </div>
      </div>
      <SearchDrawer searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
    </div>
    </div>
}

export default TopHeader;
